// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GoodsImage_wrap__w1TjV","image":"GoodsImage_image__1Wl8A","image_loading":"GoodsImage_image_loading__1xxio"};